import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';
import LandingFooter from './components/LandingFooter';
import LandingHeader from './components/LandingHeader';

const LandingPage = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    // Check if user is already logged in
    const session = localStorage.getItem('vinpro_session');
    if (session) {
      try {
        const sessionData = JSON.parse(session);
        const loginTime = new Date(sessionData.loginTime);
        const now = new Date();
        const hoursDiff = (now - loginTime) / (1000 * 60 * 60);
        
        // Session expires after 8 hours
        if (hoursDiff < 8) {
          navigate('/dashboard-overview');
          return;
        } else {
          // Clear expired session
          localStorage.removeItem('vinpro_session');
        }
      } catch (error) {
        localStorage.removeItem('vinpro_session');
      }
    }

    // Set page title
    document.title = 'VIN Pro Platform - Consultoría Profesional de VIN';
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background">
      <LandingHeader />
      <HeroSection />
      <FeaturesSection />
      <TestimonialsSection />
      <ContactSection />
      <LandingFooter />
    </div>
  );
};

export default LandingPage;